<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pa-4">
    <v-col cols="12" md="12" class="pt-0">

      <v-card flat>
        <v-card-title v-if="showTitle">
          Kanäle
          <v-spacer></v-spacer>
        </v-card-title>
        <v-row justify="center">
          <v-col cols="4" xs="12" sm="8" class="pl-4">
            <v-select
                v-model="filterTags"
                :items="tags"
                v-if="showTags"
                outlined
                chips
                value="fred"
                deletable-chips
                small-chips
                @change="reFilter"
                label="Gruppe"
                multiple
            ></v-select>
          </v-col>
          <v-col cols="12" xs="12" sm="4">
            <v-text-field
                v-model="search"
                append-icon="search"
                label="Suche"
                single-line
                hide-details
            ></v-text-field>
          </v-col>

        </v-row>
        <v-data-table
            :headers="headers"
            :items="deviceList"
            :search="search"
            show-select
            v-model="selected"
            hide-default-footer
            hide-details
            :items-per-page="-1"
        >
          <template v-slot:item.action="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
            >
              edit
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'

var _ = require('lodash')
export default {
  name: 'TableChannels',
  props: {
    companyId: String,
    showTitle: Boolean,
    removeVeranstalter: Boolean
  },
  components: {},
  methods: {
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
          dm = decimals <= 0 ? 0 : decimals || 2,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    reload: function () {
      console.log('playlist load', this.companyId)
      if (this.companyId) {
        Vue.prototype.$api.loadChannelsFromCompany(this.companyId, this.onGetData)
      } else {
        // Vue.prototype.$api.loadPlayLists(this.onGetData)
        Vue.prototype.$api.loadChannels(this.onGetData)
      }
    },
    getSelected: function () {
      return this.selected
    },
    getTags: function (item) {
      var t = JSON.parse(item.tags)
      return t
    },
    editItem: function (item) {
      this.$router.push('/Playlist/' + item.guid)
    },
    onGetData: function (result) {
      console.log('result', result)
      if (this.showAll) {
        this.deviceList = result
      } else {
        var res = []
        for (var i in result) {
          var item = result[i]
          if (!item.companyName) {
            res.push(item)
          }
        }
        this.deviceList = res
      }
    },
    reFilter: function () {
      if (this.filterTags.length === 0) {
        this.deviceList = _.clone(this.completeData)
        return
      }
      let list = []
      for (var ii in this.completeData) {
        let item = this.completeData[ii]
        let found = false
        for (var index in item.tagArray) {
          let tag = item.tagArray[index]
          console.log('list', tag, this.filterTags)
          let fIndex = _.findIndex(this.filterTags, function (o) {
            return o === tag
          })
          if (fIndex > -1) {
            found = true
            break
          }
        }
        if (found) {
          list.push(item)
        }
      }
      console.log('list', list)
      this.deviceList = list
    }
  },
  data() {
    return {

      showTags: false,
      companyItem: null,
      search: null,
      tags: [],
      completeData: null,
      selected: [],
      filterTags: [],
      headers: [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Kommentar', value: 'comment'},
        {text: 'Aktion', value: 'action'},

      ],
      deviceList: []
    }
  },
  watch: {
    selected: function (newVal) {
      this.$emit('input', newVal)
    }
  },
  mounted() {
    const cmp = this
    console.log('this', this)
    this.$nextTick(() => {
      cmp.reload()
    })
  }
}
</script>

<style scoped>

</style>
